import EnergyCredit from './views/energy-credit.c';

export default EnergyCredit;
